import React from 'react';
import { useSubtramiteForm } from '../../../hooks/useSubtramiteForm';
import { saveReserva } from '../../../services/tramiteService';
import SubtramiteForm from '../../SubtramiteForm';
import { withRequiredTramite } from './withRequiredTramite';
import { useAuthorization } from '@/auth/hooks/useAuthorization';

const Reserva: React.FC = () => {

  const {
    data,
    loading,
    init,
    isUpdate,
    setIsUpdate,
    handleChange,
    handleSubmit,
    handleFinalizarSubtramite,
    handleReabrirSubtramite
  } = useSubtramiteForm({
    subtramiteKey: 'reserva',
    defaultData: {
      certificado: null,
      certificado_path: null,
    },
    saveFunction: saveReserva,
    successMessage: 'Reserva Guardado con éxito',
    errorTitle: 'Error al grabar Reserva',
  });

  const { canManageTramites, canUploadCertificados } = useAuthorization();

  // Configuración de campos básicos
  const fields = [
    {
      type: 'toggle',
      name: 'habilitado',
      label: 'Habilitado:',
      inline: true,
      visible: canManageTramites && !isUpdate,
    },
    {
      type: 'date',
      name: 'fecini',
      label: 'Fecha de inicio:',
      inline: true,
      visible: canManageTramites && !isUpdate,
    },
  ];

  // Configuración de campos de archivos
  const fileFields = [
    {
      type: 'file',
      name: 'certificado',
      label: 'Certificado:',
      inline: true,
      visible: isUpdate,
      readOnly: !canUploadCertificados,
      helpText: 'Acción a realizar por la tramitadora',
    },
  ];

  const btnGuardarVisible = fields.some(field => field.visible) ||
    fileFields.some(field => field.visible && !field.readOnly);


  return (
    <SubtramiteForm
      title="Certificado de Reserva"
      data={data}
      loading={loading}
      init={init}
      isUpdate={isUpdate}
      setIsUpdate={setIsUpdate}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      handleFinalizarSubtramite={handleFinalizarSubtramite}
      handleReabrirSubtramite={handleReabrirSubtramite}
      btnGuardarVisible={btnGuardarVisible}
      fields={fields}
      fileFields={fileFields}
      subtramiteKey="reserva"
    />
  );
}

export default withRequiredTramite(Reserva);